import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DeepseekChatComponent } from './deepseek-chat.component';

@NgModule({
  declarations: [DeepseekChatComponent],
  imports: [CommonModule, FormsModule],
  exports: [DeepseekChatComponent]
})
export class DeepseekChatModule { }